import { Tldraw } from "@tldraw/tldraw";
import "@tldraw/tldraw/tldraw.css";
import React from "react";
import { ObjectDetails } from "../fp-api";

export function ObjectCanvasView({ object }: { object: ObjectDetails }) {
  return <Tldraw />;
}
